
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eventos/[slug]/fotos",
      function () {
        return require("private-next-pages/eventos/[slug]/fotos.js");
      }
    ]);
  